import { useMemo } from 'react'

type UseDateRangeProps = {
  numberOfDaysBefore: number
  numberOfDaysAfter?: number
  customEndDate?: Date
}

export function useDateRange(props: UseDateRangeProps) {
  return useMemo(() => {
    const today = new Date()
    const lowerBound = new Date(today.getTime())
    lowerBound.setDate(today.getDate() - props.numberOfDaysBefore)

    const upperBound = props.customEndDate
      ? new Date(props.customEndDate)
      : (() => {
          const date = new Date(today)
          date.setDate(today.getDate() + (props.numberOfDaysAfter ?? 0))
          return date
        })()

    return {
      today,
      lowerBound,
      upperBound,
      isDateInRange: (date: Date) => {
        return date >= lowerBound && date <= upperBound
      },
    }
  }, [props])
}
